var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 mt-2 mb-2"},[_c('ul',{staticClass:"bulleted-text"},_vm._l((_vm.templateItemData.list),function(item,i){return _c('li',{key:'item_' + i,domProps:{"innerHTML":_vm._s(item.text)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }